import { useAnalytics } from '../context/AnalyticsContext';

const PERIOD_LABEL = {
	0:  'Today',
	7:  'Last 7 days',
	14: 'Last 14 days',
	21: 'Last 3 weeks',
	30: 'Last 30 days',
	90: 'Last 90 days',
};

const CARDS = [
	{ key: 'totalViews',    filteredKey: 'filteredTotalViews',    label: 'Total Accesses',  icon: '👁',  accent: '#2563EB', bg: '#EFF6FF', border: '#BFDBFE' },
	{ key: 'activeModules', filteredKey: 'filteredActiveModules', label: 'Active Modules',  icon: '📦', accent: '#059669', bg: '#ECFDF5', border: '#6EE7B7' },
	{ key: 'activeUsers',   filteredKey: 'filteredActiveUsers',   label: 'Active Users',    icon: '👥', accent: '#D97706', bg: '#FFFBEB', border: '#FDE68A' },
];

export default function KpiCards() {
	const { state } = useAnalytics();
	const isFiltered  = !!state.filterType;
	const busy        = isFiltered ? state.filterLoading : state.loading;
	const periodLabel = PERIOD_LABEL[state.days] ?? `Last ${state.days} days`;

	return (
		<div style={S.row}>
			{CARDS.map(({ key, filteredKey, label, icon, accent, bg, border }) => {
				const value = isFiltered ? (state[filteredKey] ?? 0) : (state[key] ?? 0);

				return (
					<div key={key} style={{ ...S.card, borderTop: `3px solid ${accent}` }}>
						<div style={{ ...S.iconWrap, background: bg, border: `1px solid ${border}` }}>
							<span style={{ fontSize: 18 }}>{icon}</span>
						</div>
						<div style={{ ...S.value, color: accent }}>
							{busy ? '—' : value.toLocaleString('en-GB')}
						</div>
						<div style={S.labelRow}>
							<span style={S.label}>{label}</span>
							{isFiltered
								? <span style={{ ...S.badge, color: '#6366F1', background: '#EEF2FF' }}>filtered</span>
								: <span style={{ ...S.badge, color: '#64748B', background: '#F1F5F9' }}>{periodLabel}</span>
							}
						</div>
					</div>
				);
			})}
		</div>
	);
}

const S = {
	row: {
		display: 'grid',
		gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
		gap: 14, marginBottom: 20,
	},
	card: {
		background: '#FFFFFF', border: '1px solid #E4E9F0',
		borderRadius: 14, padding: '18px 20px',
		boxShadow: '0 1px 6px rgba(0,0,0,0.05)',
		display: 'flex', flexDirection: 'column', gap: 8, minWidth: 0,
	},
	iconWrap: {
		width: 38, height: 38, borderRadius: 10,
		display: 'flex', alignItems: 'center', justifyContent: 'center',
		alignSelf: 'flex-start', flexShrink: 0,
	},
	value: {
		fontSize: 32, fontWeight: 800,
		letterSpacing: '-1.5px', lineHeight: 1,
		fontFamily: "'Outfit', sans-serif",
	},
	labelRow: { display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' },
	label:    { fontSize: 12, color: '#64748B', fontWeight: 500 },
	badge: {
		fontSize: 9, fontWeight: 700,
		padding: '1px 6px', borderRadius: 8,
		textTransform: 'uppercase', letterSpacing: 0.5,
	},
};